<template lang="pug">
.c-staff-list
  .container
    .columns.is-multiline
      .column.is-6(v-for="item in items")
        .media.box
          base-url-provider(:filepath="item.photo ? item.photo.name : ''")
            template(v-slot="{ url }")
              figure.media-left
                .image.is-64x64
                  img.is-rounded(:src="url || defUser")
          .media-content
            .title.is-5 {{ item.name }}
            base-tag-job(:class="$style.tag") {{ item.job }}
            base-tag-homeland(:class="$style.tag") {{ item.homeland || '-' }}
            .columns.is-gapless.is-multiline(:class="$style.content").has-text-weight-medium
              .column.is-6
                p 電話：{{ item.telNumber || '-' }}
              .column.is-6
                p 手機：{{ item.phoneNumber || '-' }}
              .column.is-12
                p 職業：{{ item.career || '-' }}
              .column.is-12
                div
                  p email：{{ item.email || '-' }}
              .column.is-12
                p 地址：{{ item.address || '-' }}
</template>

<script>
import defUser from "@/assets/images/user-default.jpg";
import BaseUrlProvider from "@/components/BaseUrlProvider.vue";
import BaseTagJob from "@/components/BaseTagJob.vue";
import BaseTagHomeland from "@/components/BaseTagHomeland.vue";

export default {
  name: "StaffList",
  components: {
    BaseUrlProvider,
    BaseTagJob,
    BaseTagHomeland
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      defUser
    };
  }
};
</script>

<style module lang="sass">
.tag
  margin-bottom: pxRem(8)

.content
  p
    padding: pxRem(8) 0
    overflow-wrap: break-word
    font-size: pxRem(14)
</style>
